import Model from './model';
import View from './view';

export default {
	Model: Model,
	Views: {
		Main: View
	}
};

